export const buttonStyles = {
  base: 'inline-flex items-center justify-center gap-2 font-sans font-medium rounded-md transition-colors focus-visible:outline-none disabled:opacity-50 disabled:cursor-not-allowed',
  variant: {
    primary: 'bg-brand-400 text-brand-950 hover:bg-brand-600',
    secondary: 'bg-brand-900 text-brand-100 hover:bg-brand-950',
    outline: 'border border-brand-700/40 bg-transparent text-brand-950 hover:bg-brand-100',
    ghost: 'bg-transparent text-brand-950 hover:bg-brand-100',
  },
  size: {
    sm: 'text-sm min-h-10 px-3 py-2 md:min-h-9 md:py-1.5',
    md: 'text-md min-h-11 px-4 py-3 md:min-h-10 md:py-2',
    lg: 'text-lg min-h-12 px-6 py-3.5 md:min-h-11 md:py-3',
  },
  fullWidth: 'w-full',
} as const;
